export default "__VITE_ASSET__BTFnOVgf__"